export default __webpack_public_path__ + "static/3-concurrency-ab713ce9986663115e2eac045bf655db.png";